// extracted by mini-css-extract-plugin
export default {"container":"SoundAlertModal_container_VyhTG","expand":"SoundAlertModal_expand_wLcQA","modal":"SoundAlertModal_modal_N2A6k"};